module.exports = __webpack_public_path__ + "static/media/flutter.9ca247cd.svg";